export const selectSearchFormState = state => state.searchForm;
export const selectBlockerDetectorState = state => state.blockerDetector;
export const selectAgencyPhoneNumbersState = state => state.agencyPhoneNumbers;
export const selectErrorUIState = state => state.errorUI;
export const selectSideMenuModalState = state => state.sideMenuModal;
